import React from 'react';
import { motion } from 'framer-motion';
import { Lock, Zap } from 'lucide-react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  className?: string;
  href?: string;
}
export function Button({
  children,
  className = '',
  href,
  ...props
}: ButtonProps) {
  const baseClasses = 'group relative inline-flex items-center justify-center gap-3 bg-terracotta hover:bg-terracotta-hover text-white font-bold text-lg md:text-xl py-4 px-8 rounded-full transition-all duration-300 shadow-lg hover:shadow-xl hover:-translate-y-1 w-full sm:w-auto text-center';
  const content = <>
      <span data-id="element-179">👉</span>
      <span data-id="element-180">{children}</span>
    </>;
  const checkoutUrl = 'https://guias-salud.com/cart/46396169683132:1';
  const finalHref = href || checkoutUrl;
  const Wrapper = 'a';
  const wrapperProps = {
    href: finalHref,
    target: '_blank' as const,
    rel: 'noopener noreferrer' as const
  };
  return <div className={`flex flex-col items-center gap-3 ${className}`} data-id="element-181">
      <motion.div whileHover={{
      scale: 1.02
    }} whileTap={{
      scale: 0.98
    }} className="w-full sm:w-auto" data-id="element-182">
        {/* @ts-ignore */}
        <Wrapper className={baseClasses} {...wrapperProps} data-id="element-183">
          {content}
        </Wrapper>
      </motion.div>
      <div className="flex items-center gap-4 text-sm text-charcoal-light font-medium opacity-80" data-id="element-184">
        <span className="flex items-center gap-1.5" data-id="element-185">
          <Lock size={16} className="text-sage-600" data-id="element-186" /> Pago 100% seguro
        </span>
        <span className="hidden sm:inline text-sage-300" data-id="element-187">•</span>
        <span className="flex items-center gap-1.5" data-id="element-188">
          <Zap size={16} className="text-terracotta" data-id="element-189" /> Acceso instantáneo
        </span>
      </div>
    </div>;
}